export default __webpack_public_path__ + "static/media/ic-planet.1d271387.svg";